<ng-content></ng-content>

<cm-inspector-section>
    <ng-container cm-title>Transform To Value</ng-container>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'name'" [label]="'Name'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'transform'" [label]="'Transform'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'valueType'" [label]="'Value Type'" [selectionPossibilities]="$valueTypePossibilities()"></cm-value-slot>
    </ng-container>
</cm-inspector-section>
